import { DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT } from '@cp/ds/src/components/form/components/field/dateTimePicker/const';

export const DATE_FORMAT = DATE_PICKER_VALUE_DATE_FORMAT_DEFAULT;
